module.exports = __webpack_public_path__ + "img/github.f44282d5.svg";